import React from 'react';
import './footer.css'
import logo from '../images/logo.png'
import Copyright from '../copyright/Copyright'
import { Typography, Row, Col } from 'antd';
import { HomeFilled, MailFilled, PhoneFilled, WhatsAppOutlined, RightOutlined } from '@ant-design/icons';


const { Title, Text } = Typography;
function Footer() {

  return (
    <div>
      <div className="footer" id="footer">
        <div className="footer-inner">
          <Row className="footer-row" justify="center" gutter={{ xs: 8, sm: 20, md: 20, lg: 32 }} >
            <Col className="footer-col" xs={22} sm={12} md={12} lg={6} xl={6}>
              <div>
                <img className="footer-logo-img" src={logo} />

                <Text className="footer-para">
                  <p>
                    We think that App creation process starts with developer’s selection and training,
                    not when we start working on a particular application.
                  </p>
                </Text>
                <div className="footer-social-icon">
                  <a href="https://www.facebook.com/" className='iconFacebook'></a>
                  <a href="https://twitter.com/" className='iconTwitter'></a>
                  <a href="https://github.com" className='iconGithub'></a>
                  <a href="https://www.linkedin.com/" className='iconLinkedin'></a>
                  <a href="https://www.instagram.com/" className='iconInsta'></a>
                </div>
              </div>
            </Col>

            <Col className="footer-col" xs={22} sm={12} md={12} lg={6} xl={6}>
              <div>
                <h1 className="footer-sitemap-heading-1">Sitemap</h1>
                <ul className="footer-left-ul">
                  <li><RightOutlined className="footer-left-arrow" /> <a href="#">Home </a> </li>
                  <li><RightOutlined className="footer-left-arrow" /> <a href="#">About Us </a> </li>
                  <li><RightOutlined className="footer-left-arrow" /> <a href="#">Courses </a> </li>
                  <li><RightOutlined className="footer-left-arrow" /> <a href="#">News </a> </li>
                </ul>
                <ul className="footer-right-ul">
                  <li><RightOutlined className="footer-left-arrow" /> <a href="#">Gallery </a> </li>
                  <li><RightOutlined className="footer-left-arrow" /> <a href="#">Teachers </a> </li>
                  <li><RightOutlined className="footer-left-arrow" /> <a href="#">Support </a> </li>
                  <li><RightOutlined className="footer-left-arrow" /> <a href="#">Contact </a> </li>
                </ul>
              </div>
            </Col>

            <Col className="footer-col" xs={22} sm={12} md={12} lg={5} xl={6}>
              <div className="footer-sypport-col">
                <h1 className="footer-sitemap-heading">Support</h1>
                <ul className="footer-support-ul">
                  <li><RightOutlined className="footer-left-arrow" /> <a href="#">FAQS </a> </li>
                  <li><RightOutlined className="footer-left-arrow" /> <a href="#">Privacy </a> </li>
                  <li><RightOutlined className="footer-left-arrow" /> <a href="#">Support </a> </li>
                  <li><RightOutlined className="footer-left-arrow" /> <a href="#">Documentation </a> </li>
                </ul>
              </div>
            </Col>

            <Col className="footer-col" xs={24} sm={12} md={12} lg={7} xl={6}>
              <div>
                <h1 className="footer-contact-heading">Contact Us</h1>
                <ul className="footer-contactUs-ul">
                  <li><PhoneFilled className="footer-contactus-icons" />  <span className="footer-contactus-txt"> +92 111 000777123 </span> </li>
                  <li><MailFilled className="footer-contactus-icons" />  <span className="footer-contactus-txt"> skill@gmail.com</span>  </li>
                  <li><WhatsAppOutlined className="footer-contactus-icons" />  <span className="footer-contactus-txt"> +92 321 23123435 </span> </li>
                  <li><HomeFilled className="footer-contactus-icons" />  <span className="footer-contactus-txt"> Karachi, Sindh Pakistan  </span></li>
                </ul>
              </div>

            </Col>
          </Row>
        </div>
      </div>
      <Copyright />
    </div>


  )
}

export default Footer;